<template>
    <ul class="list__ul">
        <li>
            <div>
                Responsabilité Civile Automobile :
                <ul>
                    <li><strong>dommages corporels : Illimités</strong></li>
                    <li><strong>dommages matériels et immatériels : 100 000 000 euros par sinistre</strong></li>
                </ul>
            </div>
        </li>
        <li>
            <div>
                Défense Pénale et Recours Suite à Accident
            </div>
        </li>
        <li>
            <div>
                Protection juridique étendue
            </div>
        </li>
        <li>
          <div>
              Dommages Corporels du Conducteur : <strong>Jusqu’à 1 000 000 euros par sinistre</strong>
          </div>
        </li>
        <li>
          <div>
              Bris de glace : <strong>sans franchise</strong>
          </div>
        </li>
        <li>
          <div>
              Vol et tentative de vol : <strong>franchise de 300 euros - franchise doublée pour les véhicules de plus de 3,5 T.</strong>
          </div>
        </li>
        <li>
          <div>
              Incendie : <strong>franchise de 300 euros - franchise doublée pour les véhicules de plus de 3,5 T.</strong>
          </div>
        </li>
        <li>
          <div>
              Dommages Tous Accidents : <strong>franchise de 300 euros - franchise doublée pour les véhicules de plus de 3,5 T.</strong>
          </div>
        </li>
        <li>
          <div>
              Pertes financières
          </div>
        </li>
        <li>
          <div>
              Indemnisation +
          </div>
        </li>
        <li>
          <div>
              Bagages et objets personnels : <strong>3 000 euros – franchise 200 euros</strong>
          </div>
        </li>
        <li>
          <div>
              Accessoires Hors-Série : <strong>6000 euros – franchise de la garantie concernée</strong>
          </div>
        </li>
        <li>
          <div>
              Assistance : Formule 2 comprenant Extension Panne 0 km
          </div>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'GuarantyAssurancesSection',
        props: {
            guaranty: Object,
        },
        data() {
            return {
              isOui: "Oui",
              isNon: "Non",
            }
        },
        computed: {},
        methods: {
          isNewCampingCar(quoteDetails) {
            if (typeof quoteDetails !== 'undefined') {
              let isNew = (quoteDetails.is_new === this.isOui);
              return isNew;
            }
            return false;
          },
          isOptionAExists (quoteDetails) {
            return (quoteDetails && (quoteDetails.cardans === this.isOui));
          },
          isOptionBExists (quoteDetails) {
            return (quoteDetails && (quoteDetails.pumps === this.isOui));
          },
          isOptionCExists (quoteDetails) {
            return (quoteDetails && (quoteDetails.injections === this.isOui));
          },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/DealerInsuranceCampingCar/GuarantyAssurancesSection.vue